import { SearchExpression, Operator } from '../../../model/search/advanced/SearchExpression';
import { ISearch } from '../../../model/search/ISearch';
import { AdvancedSearch } from '../../../model/search/advanced/AdvancedSearch';
import { Factory } from '../../Factory';
import { BaseSearchService } from '../BaseSearchService';

namespace app.services.search.advanced {

  export class SearchService extends BaseSearchService implements IService {
    private $rootScope: IRootScope;
    private configService: app.services.IConfigService;
    private resourceWrapperService: app.services.utilities.ResourceWrapperService;
    private $resource: angular.resource.IResourceService;
    private baseUrl: string;

    constructor($resource: angular.resource.IResourceService, resourceWrapperService: ResourceWrapperService, $rootScope: IRootScope, configService: app.services.IConfigService) {
      super();
      this.$rootScope = $rootScope;
      this.configService = configService;
      this.resourceWrapperService = resourceWrapperService;
      this.$resource = $resource;
      this.baseUrl = this.configService.getServerBaseUrlForResource();
    }

    public async Search(project, collection: ICollection, search: ISearch, columnFilters: SearchExpression = new SearchExpression(), sortBy: string = null, sortDirection: SortDirection = null, page: number = 1, limit: number = 20) {
      let expression = new SearchExpression();

      expression.searchExpressions.push(search.expression);

      if (columnFilters) {
        expression.searchExpressions.push(columnFilters);
      }

      expression.operator = Operator.And;

      if (collection) {
        return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/collection/:collectionId/search/advanced/execute`, {
          id: "@id",
          collectionId: "@collectionId"
        }, {query: {method: "POST", params: {page: page, limit: limit, sortBy, sortDirection}}})).query({
          id: project.id,
          collectionId: collection.id
        }, expression).$promise;
      } else {
        return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/search/advanced/execute`, {id: "@id"}, {
          query: {
            method: "POST",
            params: {page: page, limit: limit, sortBy, sortDirection}
          }
        })).query({id: project.id}, expression).$promise;
      }
    }

    public async Save(project, search: AdvancedSearch) {
      return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/search/advanced/save`, {
        id: "@id"
      }, {query: {method: "POST"}})).query({
        id: project.id
      }, search).$promise;
    }

    public async ToggleVisibility(project, id: string) {
      return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/search/advanced/visibility/toggle/:searchId`, {
        id: "@id"
      }, {query: {method: "POST"}})).query({
        id: project.id,
        searchId: id
      }).$promise;
    }

    public async FindAll(project) {
      return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/search/advanced/all`, {}, {
        query: {
          method: "GET",
          isArray: true
        }
      })).query({
        id: project.id
      }).$promise;
    }

    public async Delete(project, id: string) {
      return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/search/advanced/delete/:searchId`, {}, {query: {method: "DELETE"}})).query({
        id: project.id,
        searchId: id
      }).$promise;
    }
  }

  frontendApp.factory("AdvancedSearchService", ['$resource', 'ResourceWrapperService', '$rootScope', 'ConfigService', function(resource, resourceWrapperService, rootScope, configService) {
    return new SearchService(resource, resourceWrapperService, rootScope, configService);
  }]);
}
